"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _MenuButton = _interopRequireDefault(require("../../Shared/MenuButton"));

var _MenuDrawerItem = _interopRequireDefault(require("../../Shared/MenuDrawerItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledMenuButton = (0, _styledComponents.default)(_MenuButton.default).withConfig({
  displayName: "SellTrade__StyledMenuButton",
  componentId: "x8y6l4-0"
})(["color:", ";height:60px;justify-content:flex-start;width:100%;"], function (props) {
  return props.theme.carvana.blue.dark;
});
var StyledMenuDrawerItem = (0, _styledComponents.default)(_MenuDrawerItem.default).withConfig({
  displayName: "SellTrade__StyledMenuDrawerItem",
  componentId: "x8y6l4-1"
})(["background-color:", ";padding:0 32px;"], function (props) {
  return props.theme.carvana.gray.background;
});

var _ref = _react.default.createElement(StyledMenuDrawerItem, {
  "data-qa": "sell-trade"
}, _react.default.createElement(StyledMenuButton, {
  dataCvTest: "headerMobileTradesLink",
  href: "/trades",
  target: "_self"
}, "Sell/Trade"));

var SellTrade = function SellTrade() {
  return _ref;
};

var _default = SellTrade;
exports.default = _default;
module.exports = exports.default;